// extracted by mini-css-extract-plugin
module.exports = {"selector":"LanguageSelector_selector__1c7bW","options":"LanguageSelector_options__1FVU8","value":"LanguageSelector_value__smqxK"};